import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../utils';

export interface getBackgroundFetchDataOption
  extends Partial<GeneralInvokeOption> {
  fetchType: String;
}

// 数据预拉取
export function getBackgroundFetchData(option: getBackgroundFetchDataOption) {
  if (!option.fetchType) {
    return logErrorAndRunFail(
      APINames.Native.GET_BACKGROUND_FETCH_DATA,
      option,
      'parameter error:parameter.fetchType should be string instead of Undefined.'
    );
  }
  return MacleJSBridge.beforeInvoke(
    APINames.Native.GET_BACKGROUND_FETCH_DATA,
    option
  );
}
